// This file is auto-generated via CI, do not edit by hand!
export enum PreisModell {
  PM_2025_01ALL = '2025_01ALL',
  PM_2025_01ALM = '2025_01ALM',
  PM_2025_01ALS = '2025_01ALS',
  PM_2025_DEFAULT = '2025_Default',
}
